import { ComposeViewState } from 'owa-mail-compose-store';

export default function canModifyRecipients(viewState: ComposeViewState) {
    const IRMData = viewState.IRMData;
    return !IRMData || IRMData.IsOwner || IRMData.ForwardAllowed;
}
